import { blankKeyText } from '_legacy/constants/gridText';
import {
    FetchMappingGridStatusDisplayValue,
    FetchMappingSelectStatusDisplayValue,
} from '../../../data/mappings';

export const StatusFormatter = (params) => {
    const { value, node, context } = params;
    if (!value) {
        return '';
    }

    if (!node) {
        return FetchMappingSelectStatusDisplayValue(value, context.datasetId);
    }

    return FetchMappingGridStatusDisplayValue(value, context.datasetId);
};

export const StatusFilterFormatter = (params) => {
    const { value, context } = params;
    if (!value) {
        return blankKeyText;
    }

    return FetchMappingSelectStatusDisplayValue(value, context.datasetId);
};
